import React from "react";

const PdfViewer = ({
    pdfUrl,
}) => {
    return (
        <iframe
            src={pdfUrl ? `${pdfUrl}#toolbar=0` : ""}
            title="pdf"
            width="100%"
            height="800"
        />
    );
};

export default PdfViewer;